import React from 'react';
import { useForm } from '@inertiajs/react';
import AuthLayout from '../../components/AuthLayout.jsx';

export default function PasswordResetEdit({ token }) {
  const { data, setData, patch, processing, errors } = useForm({
    user: {
      password: '',
      password_confirmation: '',
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    patch(`/password_resets/${token}`);
  };

  return (
    <AuthLayout>
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="flex justify-center mb-6">
            <img src="/logo.png" alt="123CEU" className="h-12 w-auto" />
          </div>
          <h2 className="mt-2 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Create new password</h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">New password</label>
              <input
                id="password"
                type="password"
                required
                autoFocus
                placeholder="Enter new password (min 8 characters)"
                value={data.user.password}
                onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
            <br />
            <div>
              <label htmlFor="password_confirmation" className="block text-sm/6 font-medium text-gray-900">Confirm password</label>
              <input
                id="password_confirmation"
                type="password"
                required
                placeholder="Confirm new password"
                value={data.user.password_confirmation}
                onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
            </div>
            <div className="mt-6">
              <button
                type="submit"
                disabled={processing}
                className="cursor-pointer flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50"
              >
                {processing ? 'Resetting...' : 'Reset password'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
}
